import { businessTheme } from "@boseo/shared/themes";

const theme = {
    ...businessTheme,
};

export default theme;
